import React, { useState, useEffect } from 'react'
import './Home.scss'
import img4 from "../../assets/images/intro/brush-large.png";
import img from "../../assets/images/intro/brush-mobile.png";
import imgD from '../../assets/images/homepage/bg-d.jpg'
import imgM from '../../assets/images/homepage/bg-m.png'
import boxM from '../../assets/images/homepage/box-mo.png'
import boxD from '../../assets/images/homepage/box.png'

const isBrowser = typeof window !== `undefined`

const Homepage = () => {
    const [height, setHeight] = useState(window.innerHeight);
    const [widthSH, setWidthSH] = useState(window.innerWidth)
    function handleWindowSizeChange() {
        setHeight(window.innerHeight);
        setWidthSH(window.innerWidth)
    }
    const [className, setClassName] = useState(true);

    useEffect(() => {
        if (height > 750) {
            setClassName(false)
        }
        else setClassName(true)
    }, [height])

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const _renderBottomImgBg = (width) => {
        if (width >= 768) {
            return <img src={img4} alt="brush" key="brush" className="homepage-bg" style={{ position: 'absolute', bottom: -35, objectFit: 'cover', width: '100%' }} />
        }
        if (width < 768) {
            return <img src={img} alt="brush" key="brush" style={{ position: 'absolute', bottom: 0, objectFit: 'cover', width: '100%' }} />
        }
    }

    const isMobile = widthSH < 768;
    return (
        isBrowser && <div style={{ position: 'relative' }}>
            {isMobile ?
                <div className='homepage-mobile' >
                    <div className='homepage-mobile-cover'>
                        <img src={imgM} alt='background' className="homepage-mobile-cover-img" />
                        <div className="homepage-mobile-box" >
                            <div className="homepage-mobile-box-img">
                                <img src={boxM} alt='background' loading="lazy" />
                            </div>
                        </div>
                    </div>
                </div>
                // <div className='homepage-mobile' >
                //     <img src={bannerMO} alt='background' />
                // </div>
                :
                <div className={`homepage-large ${className ? 'height100' : ''}`}>
                    <div className='homepage-mobile-cover'>
                        <img src={imgD} alt='background' />
                        <div className="homepage-mobile-box" >
                            <div className="homepage-mobile-box-img">
                                <img className="homepage-large-box" src={boxD} alt='background' loading="lazy" />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {_renderBottomImgBg(widthSH)}
        </div>
    )
}

export default Homepage
